// extracted by mini-css-extract-plugin
export default {"banner":"fmh-opaque-banner_banner__XUsqh","icon":"fmh-opaque-banner_icon__obaHQ","warning":"fmh-opaque-banner_warning__fBiV1","info":"fmh-opaque-banner_info__1W7yU"};